<template>
    <div>
        <v-alert
            v-bind="$attrs"
            v-on="$listeners"            
        >
          <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope" />
          </template>
          <slot>
          </slot>
        </v-alert>
    </div>
</template>

<script>
export default {
  props: {
      // message: String,
  },
  data() {
    return {
      // data: this.message,
    };
  },
}
</script>